export const Pages = {
    regions: 'regions',
    home: 'home'
}